import { render, staticRenderFns } from "./UpdatePatientSocialHistoryForm.vue?vue&type=template&id=570cc2f9&"
import script from "./UpdatePatientSocialHistoryForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePatientSocialHistoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports